import axios from 'axios'
import { getAPIUrl } from '../API'
import { v4 as uuid } from 'uuid'

export interface SearchPropertyByErfRequest {
  erfNo: string
  region: string
}

export interface ErfResponse {
  uuid: string
  cmaid: number
  erfNo: string
  allotment: string
  streetNo: string
  address: string
  suburb: string
  mun_name: string
}

export type PropertySearchByErfResponse = ErfResponse[]

export const searchPropertyByErf: (
  options: SearchPropertyByErfRequest,
) => Promise<PropertySearchByErfResponse> = async (options) => {
  const { data } = await axios.post(
    `${getAPIUrl()}/BridgingFinance/searchpropertybyerf`,
    options,
    {
      headers: {
        Authorization: `Bearer ${await sessionStorage.getItem('jwt')}`,
      },
    },
  )
  if (!data.data) {
    alert(`No results found for Erf number: ${options.erfNo}`)
  }
  console.log(data, 'data inside searchPropertyByErf.ts')
  return (data.data as ErfResponse[]).map((item) => ({ ...item, uuid: uuid() }))
}
